import { forwardRef, ForwardedRef } from "react";
import { LinkMenuItem as LinkMenuItemType } from "../../header-menu/HeaderMenuTypes";
import BaseMenuItem from "./BaseMenuItem";

interface LinkMenuItemProps {
  item: LinkMenuItemType;
  itemIndex: number;
}

export default function LinkMenuItem({
  item: { ...baseMenuItem },
  itemIndex,
}: LinkMenuItemProps) {
  return <BaseMenuItem {...baseMenuItem} itemIndex={itemIndex} />;
}

interface LinkButtonProps {
  url: string;
}

const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(function (
  { url }: LinkButtonProps,
  ref: ForwardedRef<HTMLAnchorElement>
) {
  return <a href={url} ref={ref} />;
});
